import React from 'react';

import { Enrollment } from '../types';
import CareTable from './CareTable';

const EnrollmentPanel: React.FC<{ enrollment?: Enrollment }> = ({ enrollment }) => (
    <CareTable
        collapsible
        title={`Enrollment this month${enrollment ? ` — ${enrollment.total_patients} distinct patients` : ''}`}
        columns={['Program', 'Patients', 'Enrolled this month', 'Disenrolled this month']}
        rows={
            enrollment
                ? Object.entries(enrollment.by_program).map(([program, line]) => [
                      program,
                      line.patients,
                      line.enrolled_this_month,
                      line.disenrolled_this_month
                  ])
                : undefined
        }
        explanations={enrollment ? [enrollment.explanation] : []}
    />
);

export default EnrollmentPanel;
